import { TReadingSkillIndex } from "@/view/GuidedHighlightingContainer/utils/GuidedHighlighting.constants";

export enum GUIDED_HIGHLIGHTING_QUESTION_STATUSES {
  initial,
  tryAgain,
  completed,
}

export const GUIDED_HIGHLIGHTING_MAX_ATTEMPTS = 2;

export interface IGuidedHighlightingQuestion {
  id: string;
  readingSkill: TReadingSkillIndex;
  question: string;
  suggestedAnswer: {
    content: string;
    prosemirrorStartIndex: number;
    prosemirrorEndIndex: number;
  };
  contentType: string;
  reported?: boolean;
  isActive?: boolean;
  attempt?: number;
  startIndex?: number | undefined;
  endIndex?: number | undefined;
  tokensEarned?: number;
  isCorrect?: boolean | undefined;
  selectedText?: string | undefined;
  articleId?: string | undefined;
  lexileLevel?: string | string[] | undefined;
  assignmentId?: string | string[] | undefined;
  guidedHighlightingId?: string | undefined;
  status?: GUIDED_HIGHLIGHTING_QUESTION_STATUSES | undefined;
}

export interface IGuidedHighlightingLevel {
  id: string;
  language: string;
  isActive: boolean;
  questions: IGuidedHighlightingQuestion[];
  gradeBand: string;
  article_level_id: string;
}

export interface IGuidedHighlightingContent {
  id: string;
  createdDate: string;
  modifiedDate: string;
  checksum: string;
  contentType: string;
  data: {
    id: string;
    levels: IGuidedHighlightingLevel[];
    contentType: string;
    assessmentType: string;
  };
}

export interface IPreviousAnswer {
  id: string;
  legacyId: string | null;
  type: string;
  dateArchived: string | null;
  dateCreated: string;
  dateModified: string;
  article: {
    id: number;
    contentId: string;
    authorDisplayName: string;
    gradeLevel: number;
    isOriginal: boolean;
    lexileLevel: number;
    title: string;
  };
  startIndex: number;
  endIndex: number;
  start_index: number;
  end_index: number;
  relatedTo: string | null;
  user: {
    id: number;
    pk: number;
    uniqueId: string;
    firstName: string;
    lastName: string;
    username: string;
  };
  metadata: {
    penName: string;
    text: string;
    readingSkill: string;
    lexileLevel: string;
    is_correct: boolean;
    attemptNumber: number;
    points: number;
    assignmentId: string;
    articleId: string;
    question_id: string;
  };
}

export interface IAttachment {
  id: string;
  createdDate: string;
  modifiedDate: string;
  checksum: string;
  content_type: string;
  data: {
    id: string;
    levels: IGuidedHighlightingLevel[];
    content_type: string;
    assessment_type: string;
  };
}

export interface IGuidedHighlightingFeedback {
  userId: string;
  contentId: string;
  contentType: string;
  reaction: string;
  rationale: string;
  dateCreated: string;
}

// Recursive type to convert snake_case keys to camelCase
export type SnakeToCamel<T> = T extends object
  ? {
      [K in keyof T as K extends string
        ? `${Uncapitalize<K>}`
        : K]: SnakeToCamel<T[K]>;
    }
  : T;
